import {useAppSelector} from '@/hooks';
import useToggleLoadingNotificationOnPanelOpenClose from '@Hooks/useToggleLoadingNotificationOnPanelOpenClose';
import {AI_SUBTITLE_PANEL_ID} from '@Panels/ai-subtitle-panel/ai-subtitle-panel.types';
import {AI_SUBTITLES_GENERATION_LOADING_KEY} from '@Panels/ai-subtitle-panel/components/ai-subtitle-generating/ai-subtitle-generating.types';
import {AiSubtitleState} from '@Components/poster-editor/components/poster-ai/poster-ai.types';

export const useToggleNotificationOnAISubtitlesGenerating = (): void => {
  const aiSubtitleState = useAppSelector((state) => {
    return state.posterEditor.aiState.aiSubtitles;
  });
  const aiSubtitlesReduxState = useAppSelector((state) => {
    return state.aiSubtitle;
  });

  useToggleLoadingNotificationOnPanelOpenClose({
    panelId: AI_SUBTITLE_PANEL_ID,
    loadingKey: AI_SUBTITLES_GENERATION_LOADING_KEY,
    loadingText: `${window.i18next.t('pmwjs_generating')} (${aiSubtitlesReduxState.generationsBatch.currentNumberOfCompletedGenerations} of ${aiSubtitlesReduxState.generationsBatch.totalItemsToGenerateSubtitlesFor})`,
    showLoadingState: aiSubtitleState === AiSubtitleState.GENERATING,
  });
};
